/** Label of the weekly charge line that tops up the Saldo de Negociações. */
export const NEGOTIATION_TOPUP_LABEL = "Recarga do Saldo de Negociações";
